import { GalleryNode } from '@prezly/story-content-format';
export var DEFAULT_GALLERY_WIDTH_SSR = {
  [GalleryNode.Layout.CONTAINED]: 720,
  [GalleryNode.Layout.EXPANDED]: 840,
  [GalleryNode.Layout.FULL_WIDTH]: 1280
};
export var IMAGE_PADDING = {
  [GalleryNode.Padding.SMALL]: 0,
  [GalleryNode.Padding.MEDIUM]: 2,
  [GalleryNode.Padding.LARGE]: 8
};
export var IMAGE_SIZE = {
  [GalleryNode.ImageSize.XSMALL]: 110,
  [GalleryNode.ImageSize.SMALL]: 200,
  [GalleryNode.ImageSize.MEDIUM]: 300,
  [GalleryNode.ImageSize.LARGE]: 450,
  [GalleryNode.ImageSize.XLARGE]: 1000
};